import { render, staticRenderFns } from "./DistributingRun.vue?vue&type=template&id=2715915e&scoped=true"
import script from "./DistributingRun.vue?vue&type=script&lang=js"
export * from "./DistributingRun.vue?vue&type=script&lang=js"
import style0 from "./DistributingRun.vue?vue&type=style&index=0&id=2715915e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715915e",
  null
  
)

export default component.exports